import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-more-02',
	templateUrl: './icon-more-02.component.svg',
})
export class IconMore02Component {}
